<template>
    <div class="check-out-panel">
        <b-navbar class="px-2 mb-3" toggleable="md" type="dark" variant="primary">
            <b-navbar-brand href="#"><span class="ml-4">Checkout Notes for {{ patientName }}</span></b-navbar-brand>
            <b-navbar-toggle class="ml-auto" target="nav_collapse3"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse3">
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">
                <button type="button" id="close-tooltip" class="btn mr-xs btn-default btn-sm" @click="closeSlideOutPanel"><i class="la la-remove"></i></button>
                <b-tooltip target="close-tooltip" triggers="hover">
                    Close
                </b-tooltip>
                </b-nav-item>                
            </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <PopupErrorDisplay/>

        <b-container fluid>
            <b-row>
                <b-col class="user-first-panel">
                    <div class="pull-right">
                        <b-button variant="success" type="submit" class="btn-sm mt-2 ml-2" @click="save();">Save & Checkout</b-button>                        
                        <b-button variant="gray" type="submit" class="btn-sm mt-2 ml-2" @click="setErrored2(false);setMessage2('');closeSlideOutPanel();">Cancel Checkout</b-button>                        
                    </div>
                    <div>
                        <b-row align-h="between" align-v="center" class="user-profile-header pt-2">
                            <b-col cols="auto" class="mr-auto">
                            <div style="float:left;">  
                                <span class="thumb-lg mb-2">
                                    <img src="../../assets/people/user2.png" alt="..." />
                                </span>
                            </div>
                            <div style="width:100%;clear:right;" class="text-nowrap pt-2">
                                <span class="fw-semi-bold mt-4" style="font-size:1.30rem;">{{ patientName }}
                                <!--
                                <span class="fw-normal">39M&nbsp;</span>
                                -->                                
                                </span>  
                            </div>
                            </b-col>            
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="patientNum && checkoutNotes">
                <b-col md="6">
                    
                    <!-- row for out of pocket and pending account -->
                    <b-row >
                        <b-col>
                            <Widget>
                                <div class="pull-right" v-if="patientOutofPocket && patientOutofPocket.length > 0">
                                    <p>{{patientOutofPocket[0].ProcDescript}}</p>                     
                                </div>
                                <div>
                                    <p>Appointment Procedure(s)</p>
                                </div>

                                <!--
                                <div class="pull-right" v-if="patientOutofPocket && patientOutofPocket.length > 0">
                                    <p>{{patientOutofPocket[0].PatientOOP | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</p>                     
                                </div>
                                <div>
                                    <p>Out of pocket obligation</p>
                                </div>
                                -->

                                <div class="pull-right">
                                    <p v-if="patientBalance && patientBalance.length > 0 && patientBalance[0].PatientAmount < 1">{{patientBalance[0].PatientAmount | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</p>                                    
                                    <b-alert v-else-if="patientBalance && patientBalance.length > 0 && patientBalance[0].PatientAmount > 1" class="mt-2" variant="danger" show>
                                        <span class="fw-semi-bold  mt-sm text-white">{{patientBalance[0].PatientAmount | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                                    </b-alert>
                                </div>
                                <div>
                                    <p v-if="patientBalance && patientBalance.length > 0">Pending Account Balance (Guarantor: {{ patientBalance[0].Guarantor }})</p>
                                </div>
                            </Widget>
                        </b-col>
                    </b-row>
                    <!-- row for Next visit and Notes-->
                    <b-row>
                        <!-- Next visit col -->
                        <b-col md="6">
                            <Widget class="quickNotes">
                                <h5 class="mt-2 mb-4 fw-bold">Quick Notes</h5>
                                <span v-if="!quickNotes">You do not have any quick notes set up. Please use settings to set that up</span>                             
                                <b-form-group v-else class="abc-checkbox" v-for="(value, key) in quickNotes" :key="key">
                                    <h6>{{ value.title }}</h6>                                    
                                    <b-form-checkbox v-for="(option,index) in value.val" :key="index" v-model="option.checked" unchecked-value="FALSE" @input="insertQuickNotes($event, key, index)">                                        
                                        <span class="fw-semi-bold">{{ option.name }}</span>
                                    </b-form-checkbox>                            
                                </b-form-group>
                            </Widget> 
                        </b-col>
                        <!-- notes col -->
                        <b-col md="6">
                            <Widget>                        
                                <h5 class="mt-2 mb-4 fw-bold">Notes</h5>                                
                                <textarea rows="6" v-model="notes" max-rows="6" cols="10" name placeholder="Try to add few new lines..." class="form-control"></textarea>
                                <b-form-checkbox v-model="sendEmail" unchecked-value="FALSE" :disabled="!isSendEmailEnabled">
                                    <span class="fw-semi-bold">
                                        Add this patient to a list of follow-up calls to be sent via email to Dr. {{ this.provider.FName }} {{ this.provider.LName }}
                                    </span>
                                    <span id="help_sendemail" class="font-size:18px;"><i  class="fa fa-question-circle text-warning" style="font-size:18px;"></i></span>
                                    <b-popover target="help_sendemail" triggers="hover focus" placement="right" :show.sync="showSendEmailHelpPopOver">
                                        <template v-slot:title><h5 class="mt-2 fw-semi-bold">What does this mean?</h5></template>
                                        <div class="help_popover">
                                            <p>This will add this patient to a list of patients to be emailed to the provider according to your settings.</p>
                                            <!--
                                                <div class="d-flex">
                                                <i class="glyphicon glyphicon-chevron-right text-muted mr-3"></i>
                                                <p class="text-muted small">You may not have Email enabled on your account yet</p>
                                                </div>
                                                <div class="d-flex">
                                                <i class="glyphicon glyphicon-chevron-right text-muted mr-3"></i>
                                                <p class="text-muted small">Patient Email may be empty in Open Dental</p>
                                                </div>
                                            -->
                                        </div>
                                    </b-popover>
                                </b-form-checkbox>
                                <small v-if="!isSendEmailEnabled" class="text-muted d-block mt-1">
                                    Send Email time must be configured in Practice Pulse Settings first to enable this.
                                </small>
                            </Widget>
                        </b-col>
                    </b-row>
                    
                    <!-- Recall appointments -->
                    <b-row>
                        <b-col>
                            <Widget>
                                <h5 class="mt-2 mb-4 fw-bold">Recall</h5>
                                <div v-if="patientFamilyRecall && patientFamilyRecall.length > 0" class="table-resposive">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Age</th>
                                        <th>Recall Scheduled</th>
                                        <th>Recall Due</th>
                                        <th>Last Recall Appointment</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(appt,index) in this.patientFamilyRecall" :key="`appt-${index}`">
                                        <td><a href="#" @click="gotoPatientPage(appt.PatNum)">{{formatName(appt.LName + ', ' +  appt.FName)}}</a></td>
                                        <td>{{appt.Age}}</td>
                                        <td v-if="appt.AptDateTime">{{appt.AptDateTime | dateformat(dateFormatStr)}}</td>
                                        <td v-else><span class="badge mr-xs badge-danger badge-pill">Not Scheduled!</span></td>
                                        <td>{{appt.RecallDue | dateformat(dateFormatStr)}}</td>
                                        <td>{{appt.PreviousRecall | dateformat(dateFormatStr)}}</td>
                                        <td>
                                          <span class="badge mr-xs badge-default badge-pill">{{appt.Status}}</span>
                                        </td>
                                      </tr> 
                                    </tbody>
                                  </table>
                                </div>  
                            </Widget>
                        </b-col>
                    </b-row>

                </b-col>
                <b-col md="6">
                    <h5 class="mt-2 mb-4 fw-bold">Tasks</h5>
                    <Widget>
                        <!--
                        <b-row>
                            <b-col xs="12">
                            <h5><span class='fw-semi-bold'>Tasks</span></h5>
                            </b-col>
                        </b-row>          
                        -->                        
                        <at at="@" :members="activeEmployees" name-key="Name" v-model="newTodoContent" v-if="employees" ref="empat">
                            <template slot="item" slot-scope="s">
                                <span tabindex="-1">{{s.item.Name}}</span>
                            </template>
                            <template slot="embeddedItem" slot-scope="s">
                                <span>
                                    <span tabindex="-1" :data-teamio-employeeid="s.current.EmployeeID" class="badge mr-xs badge-primary badge-pill mt-1">{{s.current.Name + " "}}</span>
                                </span>
                            </template>
                            <div class="ToDo__addNew newtodo" 
                                id="newtodo"
                                ref="newtodo"                    
                                placeholder="Add your task here...(use @ to assign the task to someone)" 
                                contenteditable
                            />
                        </at>
                        
                        <div>
                            <b-button variant="success" type="submit" class="btn-sm mt-2" @click="saveTodo">Add Task</b-button>                            
                        </div>

                        <div class="mt-5">
                            <!--
                            <b-row v-if="!detailData.tasks || detailData.tasks.length === 0">
                            <span class="ml-4">No tasks found</span>
                            </b-row>
                            -->
                            <todo-item
                                v-for="(item, index) in tasksTaggedWithPatient"
                                :key="item.key"
                                :item="item"
                                :moreThanOneItems="tasksTaggedWithPatient.length > 1"  
                                :isLoading=false        
                                @change="handleItemChange"
                                @edit="editItem($event, index, null)"
                                @delete="deleteTaskItem"
                                @deleteThisInstanceOnly="deleteThisInstanceOnly"              
                            />
                        </div>
                    </Widget>                   
                    <slideout-panel ref="taskdetailspage"></slideout-panel>

                    <!-- planned appointments -->                    
                    <Widget>
                        <h5 class="mt-2 mb-4 fw-bold">Planned Appointments</h5>
                        <span v-if="patientPlannedAppts && patientPlannedAppts.length === 0">No Planned Appointments found</span>
                        <div v-else-if="patientPlannedAppts && patientPlannedAppts.length > 0" class="table-resposive">
                            <table class="table">
                            <thead>
                                <tr>
                                <th>Procedure(s)</th>
                                <th>Note</th>
                                <th>Provider</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(appt, index) in patientPlannedAppts" :key="index">
                                    <td><small>{{appt.ProcDescript}}</small></td>
                                    <td><small>{{appt.Note}}</small></td>
                                    <td><small>{{appt.Provider}}</small></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </Widget>
                        
                </b-col>
            </b-row>
        </b-container>        
    </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import Widget from '@/components/Widget/Widget';
import mixin from '../../mixin.js';
import ppmixin from './Ppmixin.js';
import PopupErrorDisplay from "@/components/ErrorDisplay/PopupErrorDisplay";
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import _ from 'lodash';
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import TodoItem from '../TaskList/components/TodoItem';
import TodoDetails from '../TaskList/components/TodoDetails';
import At from '../TaskList/vueat/At';

export default {
    name: 'CheckoutNotes',
    components: {PopupErrorDisplay, Multiselect, Widget, DatePicker, TodoItem, TodoDetails, At},        
    mixins: [mixin, ppmixin],
    props: ['aptNum', 'patientNum', 'patientName', 'practicePulseSettings', 'patientItem'],

    async mounted() {      
        this.setCaretAtBeginning();        
    },

    async created() {
        this.init();
    },

    // vue2-slideout-panel UNMOUNTS this component when the panel closes. It is opened via
    // `this.$showPanel({ component: CheckoutNotes, ... })` in PracticePulse.vue:1195, and the panel
    // library destroys the mounted component on close — so beforeDestroy is the correct teardown
    // point for the Firestore listener init() opens (see teardownPatientTasksListener below).
    beforeDestroy() {
        this.teardownPatientTasksListener();
    },

    data(){
        return {                        
            showSendEmailHelpPopOver: false,
            checkoutNotes: [],               
            quickNotesOptions: {
                "New Visit": [
                    {name: 'Next Recall appointment has been scheduled', checked: false}, 
                    {name: 'Recall 3', checked: false}, 
                    {name: 'Recall 4', checked: false}, 
                    {name: 'Recall 5', checked: false}
                ],
                "Invisalign": [
                    {name: 'Scan', checked: false}, 
                    {name: 'Check and Delivery', checked: false}, 
                    {name: 'Delivery with IPR', checked: false}, 
                    {name: 'Remove attachment', checked: false}, 
                    {name: 'POCheck', checked: false}, 
                    {name: 'Cont Tx', checked: false}, 
                    {name: 'Cementation', checked: false}, 
                    {name: 'Delivery', checked: false}
                ],
                "Dispense": [
                    {name: 'Sheet White', checked: false}
                ]
            },
            quickNotes: [],
            notes: '',
            sendEmail: 'FALSE',
            newTodoContent: '',
            editInProgress: false,
            provider: null,
            // Holds the unsubscribe fn returned by tasks/getTasksTaggedWithPatient so beforeDestroy
            // can tear down the shared-slot Firestore listener. null when no listener is live.
            patientTasksUnsubscribe: null,
        }
    },

    methods: {
        ...mapActions('practicepulse', ['saveCheckoutNotes', 'getCheckoutNotes']),
        ...mapActions('tasks', ['getTasksTaggedWithPatient', 'getTaskDetails', 'addPersonalTask', 'updateTask', 'updateMultipleTasks', 'deleteTask', 'deleteThisInstanceOfRepeatedTask']),

        async init() {
            this.provider = this.getProviderFromProvNum(this.patientItem.provNum);
            // `tasks/getTasksTaggedWithPatient` opens a Firestore onSnapshot on the SHARED Vuex slot
            // `state.tasks.tasksTaggedWithPatient` and registers its unsubscribe. If this panel never
            // tears the listener down, a stale listener keeps writing that shared slot for the rest of
            // the session and overwrites OTHER consumers (notably PatientProfile's PatientTasksCard).
            // So: tear down any previous listener FIRST (init only runs once per instance via
            // created(), and there is no watcher re-invoking it — but teardown-first makes any future
            // re-entry safe), then KEEP the returned unsubscribe for beforeDestroy(). Reference
            // teardown pattern: src/pages/PatientProfile/components/PatientTasksCard.vue.
            this.teardownPatientTasksListener();
            this.patientTasksUnsubscribe = await this.getTasksTaggedWithPatient({ siteID: this.siteID, patientToLookFor: this.patientNum });
            this._getCheckoutNotes();
        },

        // Tear down the shared-slot Firestore listener opened by getTasksTaggedWithPatient().
        // Mirrors PatientTasksCard.vue::teardown(): unsubscribe, drop it from the customer store's
        // listener registry, then reset the shared slot so a stale listener can't overwrite another
        // consumer. The unsubscribe call is guarded so a throw can never leave the slot un-reset.
        teardownPatientTasksListener() {
            if (typeof this.patientTasksUnsubscribe === 'function') {
                try {
                    this.patientTasksUnsubscribe();
                    this.$store.commit('customer/removeFirestoreListener', this.patientTasksUnsubscribe);
                } catch (err) {
                    console.log('CheckoutNotes: error tearing down patient tasks listener', err);
                }
            }
            this.patientTasksUnsubscribe = null;
            this.$store.commit('tasks/resetTasksTaggedWithPatient');
        },

        insertQuickNotes(e, key, index) {
            //console.log('insert quick notes', e, key, index);
            //console.log('typeof e', typeof(e));
            
            if(typeof(e) === 'boolean' && e === true) {
                if(this.practicePulseSettings.quickNotesOptions2[key].val[index].autoNotes !== '') {
                    if(this.notes === '')
                        this.notes = this.practicePulseSettings.quickNotesOptions2[key].val[index].autoNotes;
                    else
                        this.notes = this.notes + '\n' + this.practicePulseSettings.quickNotesOptions2[key].val[index].autoNotes;                
                }
            } else {
                // this means it was deselected. Remove the auto text from notes
                this.notes = this.notes.replace(this.practicePulseSettings.quickNotesOptions2[key].val[index].autoNotes, '');
            }
        },

        async _getCheckoutNotes() {
            //console.log('quickNotesOptions2', this.practicePulseSettings.quickNotesOptions2);
            let payload = {
                siteID: this.siteID,                
                aptNum: this.aptNum,
                patNum: this.patientNum,
                _date: moment().format('YYYY-MM-DD')
            }
            this.checkoutNotes = await this.getCheckoutNotes(payload);
            console.log('this.checkoutNotes', this.checkoutNotes);
            if(this.checkoutNotes.length > 0) { 
                if(this.checkoutNotes[0].length > 0) {
                    this.quickNotes = this.checkoutNotes[0][0].QuickNotes ? JSON.parse(this.checkoutNotes[0][0].QuickNotes) : this.quickNotesOptions;                    
                    this.notes = this.checkoutNotes[0][0].Notes ? this.checkoutNotes[0][0].Notes : '';
                    this.sendEmail = this.checkoutNotes[0][0].SendEmail === 'TRUE' ? true : 'FALSE';
                } else {
                    this.quickNotes = this.practicePulseSettings.quickNotesOptions2;
                    this.notes = '';                    
                }
            } else {
                this.quickNotes = this.practicePulseSettings.quickNotesOptions2;
                this.notes = '';
            }
            //console.log('quickNotes', this.quickNotes);
        },

        async closeSlideOutPanel(payload) {          
          this.$emit('closePanel', payload);
        },

        async save() {
            console.log('patientItem', this.patientItem);

            /*
            let employeeID = this.getEmployeeIDFromProvNum(this.patientItem.provNum);

            if(!employeeID) {
                this.setErrored2(true);
                this.setMessage2("EmployeeID for this provider is missing. Please contact Teamio Support");
                return false;
            }
            */

            let arrived, aptDateTime, ready, treatmentStarted, checkout;

            if(this.patientItem.dateTimeArrived)
                arrived = new Date(this.patientItem.dateTimeArrived.seconds * 1000);
            else {
                if(this.patientItem.dateTimeReady)
                    arrived = new Date(this.patientItem.dateTimeReady.seconds * 1000);
                else
                    arrived = null;
            }            
            console.log('arrived', arrived);

            //aptDateTime = moment(new Date(this.patientItem.aptDateTime.seconds * 1000)).tz(this.allSettings.GENERAL_TIMEZONE.PropertyValue).format('YYYY-MM-DD HH:mm:ss');
            aptDateTime = new Date(this.patientItem.aptDateTime.seconds * 1000);
            console.log('aptDateTime', aptDateTime);
            
            if(this.patientItem.dateTimeReady) {
                //ready = moment(new Date(this.patientItem.dateTimeReady.seconds * 1000)).tz(this.allSettings.GENERAL_TIMEZONE.PropertyValue).format('YYYY-MM-DD HH:mm:ss');
                ready = new Date(this.patientItem.dateTimeReady.seconds * 1000);
            }
            else
                ready = null;

            console.log('ready', ready);

            if(this.patientItem.dateTimeTreatmentStarted) {
                //treatmentStarted = moment(new Date(this.patientItem.dateTimeTreatmentStarted.seconds * 1000)).tz(this.allSettings.GENERAL_TIMEZONE.PropertyValue).format('YYYY-MM-DD HH:mm:ss');
                treatmentStarted = new Date(this.patientItem.dateTimeTreatmentStarted.seconds * 1000);
            }
            else
                treatmentStarted = null;

            console.log('treatmentStarted', treatmentStarted);

            if(this.patientItem.dateTimeCheckout)
                checkout = new Date(this.patientItem.dateTimeCheckout.seconds * 100);
            else
                checkout = moment();
            
            console.log('checkout', checkout);            

            let payload = {         
                siteID: this.siteID,
                _date: moment().format('YYYY-MM-DD'),
                aptNum: this.aptNum,
                patNum: this.patientNum,
                quickNotes: this.quickNotes,
                notes: this.notes,
                procDescript: this.patientItem.procDescript,
                userODNum: this.user.ODUserNum,
                //employeeID: employeeID,
                employeeID: this.userID,
                provNum: this.patientItem.provNum,
                aptDateTime: aptDateTime,
                arrived: arrived,
                ready: ready,
                treatmentStarted: treatmentStarted,
                checkout: checkout,
                sendEmail: this.sendEmail === true ? 'TRUE' : 'FALSE',
                //dismissed: this.patientItem.dateTimeDismissed ? this.patientItem.dateTimeDismissed.toDate() : null,
            }            

            console.log('payload', payload);
            
            try {
                await this.saveCheckoutNotes(payload);                     
                this.closeSlideOutPanel({checkout: true});
            } catch(err) {
                console.log(err);
            }
        },

        gotoPatientPage(patNum) {
            let teamioPatientID = `${this.siteID}-${patNum}`;
            let routeData = this.$router.resolve({name: 'patientprofile', params: {patientID:  teamioPatientID}});
            window.open(routeData.href, '_blank');
         },
        
        setCaretAtBeginning() {
            var el = document.getElementById("newtodo");
            if(el !== null) {
            var range = document.createRange();
            var sel = window.getSelection();
            range.setStart(el, 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
            el.focus();
            }
        },

        async handleItemChange (item) {
            //console.log(`handleItemChange called with item: ${JSON.stringify(item)}`);
            await this.updateTask(item);
        },

        async deleteTaskItem(item) {
            //console.log(`trying to delete item: ${JSON.stringify(item)}`);
            await this.deleteTask(
                {   id: item.id,
                    deleted: true,
                    deletedBy: this.userID,
                    deletedOn: moment().toDate(),
                });
        },

        async deleteThisInstanceOnly(item) {
            let payload = {
            task : item,
            clientDateFormat : this.allSettings.GENERAL_TIMEZONE.PropertyValue.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
            }
            //console.log(`payload: ${JSON.stringify(payload)}`);
            await this.deleteThisInstanceOfRepeatedTask(payload);
        },

        getLinkedEmployeeID(content) {
            let regex = /data-teamio-employeeid="([a-zA-z0-9\-]+).*?/g;
            let result = regex.exec(content);
            let result1 = content.match(regex);
            //console.dir(result1);
            //console.log(`result1: ${JSON.stringify(result1, null, ' ')}`);

            if(result1 && result1.length > 1) {
            // User has @mentioned multiple people. Warn them that they can only assign the task to 1 person
            throw new Error("You tried to assign the task to more than one person. You can only @mention at max one person");
            }

            if(result) {
                //console.log(`result: ${JSON.stringify(result, null, ' ')}`);
                return result[1];
            } else
                return null;
        },

        getLinkedWikiPageID(content) {
            let regex = /data-teamio-wikipageid="([a-zA-z0-9\-]+).*/;
            let result = regex.exec(content);
            if(result) {
                //console.log(`regex result: ${result}`);
                return result[1];
            } else
                return null;
        },

        getTaggedPatientIDs(content) {
            //let regex = /data-teamio-patientid="([a-zA-z0-9\-]+).*/;
            let regex = /data-teamio-patientid=\"([0-9]+)\.?/;
            let m;
            let ret = [];

            while((m = regex.exec(content)) !== null) {
            //console.log(m);
            if(m.length > 0) {
                ret.push(parseInt(m[1],10));
                content = content.substring(m.index+1); 
            }
            }
            return ret;
        },

        ensurePatientTagged(content) {
            let taggedPatients = this.getTaggedPatientIDs(content);
            if(!taggedPatients.includes(this.patientNum)) {
            //console.log('current patnum not tagged. now tagging');
            let patient = this.getPatient(this.patientNum);
            //console.log('patient', patient);
            let html = `&nbsp; <span data-at-embedded="" contenteditable="false"> <span data-v-422f84db="" class="badge mr-xs badge-secondary badge-pill mt-1" data-teamio-patientid="${this.patientNum}"><a data-v-422f84db="" href="/app/patientprofile/${this.siteID}-${this.patientNum}" class="">${patient.LName},${patient.FName}</a></span> </span>`;
            return content = content + html;
            }
        },

        // remove the tag of who this task is assigned to when saving
        removedAssignedTo(content) {
            let regex = /<span data-at-embedded="" contenteditable="false"> <span class="badge mr-xs badge-primary.*data-teamio-employeeid="([a-zA-z0-9\-]+).*?<\/span>\s+<\/span>/;
            let temp = content.replace(new RegExp(regex, "gm"), '');
            return temp;
        },

        async opentaskdetails(taskID) {
            //console.log(`Got ${taskID} in opentaskdetails`);
            try {
            let task = await this.getTaskDetails({taskID: taskID});
            //console.log(`task: ${JSON.stringify(task)}`);
            this.editInProgress = true;

            const panel1Handle = this.$showPanel({
                component : TodoDetails,
                openOn: 'right',
                width: 750,
                props: {
                task: task,
                wikiPages: this.wikiPages,
                patients: this.patients,
                }
            })

            panel1Handle.promise
                .then(result => {
                //console.log(`panel handle promise done`);
                this.editInProgress = false;
            });
            } catch(error) {
            this.editInProgress = false;
            console.log(`Error while trying to edit task: ${error}`);
            panel1Handle.hide();
            }
        },

        async editItem(item, index, taskType) {
            let task;
            try {
            task = await this.getTaskDetails({taskID: item.id});
            //console.log(`task: ${JSON.stringify(task)}`);  

            const panel1Handle = this.$showPanel({
                component : TodoDetails,
                openOn: 'right',
                width: 750,
                props: {
                task: task,
                wikiPages: this.wikiPages,
                patients: this.patients,
                }
            })

            panel1Handle.promise
                .then(result => {
                console.log(`panel handle promise done`, result);
                //Vue.set(temp, index, false);
            });
            } catch(error) {
            console.log(`Error while trying to edit task: ${error}`);
            //Vue.set(temp, index, true);
            }
        },

        async saveTodo () {
            /*
            console.log(`innerText: ${this.$refs['newtodo'].innerText}`);
            console.log(`innerHtml: ${this.$refs['newtodo'].innerHTML}`);
            console.log(`textContent: ${this.$refs['newtodo'].textContent}`);
            console.log(`i am in save: ${this.$refs['newtodo']}`);
            */

            let content = this.$refs['newtodo'].innerText;
            let contentHTML = this.$refs['newtodo'].innerHTML;

            // do nothing if we have no content
            if (!content) return;
            
            //console.log(`content: ${content}`);
            //console.log(`contentHTML: ${contentHTML}`); 
            
            let assignedToEmpID;

            try {
                assignedToEmpID = this.getLinkedEmployeeID(contentHTML);
                //console.log(`Assigned to: ${assignedToEmpID}`);
                contentHTML = this.removedAssignedTo(contentHTML);
                //console.log(`after removal: ${contentHTML}`);
            } catch(err) {
                console.log(err);                
                this.$toast.error('You can only @mention ONE person who will be assigned this task. Please fix this and try again');
                return;
            }

            contentHTML = this.ensurePatientTagged(contentHTML);

            if(!contentHTML || contentHTML === '') {                
                this.$toast.error('Please enter a task description before submitting');
                return;
            }          

            assignedToEmpID = assignedToEmpID ? assignedToEmpID : this.userID;
            //console.log(`max: ${this.maxSortID}`);
            this.maxSortID = _.max(_.map(this.todoItems, 'sortID'));
            //console.log(`max: ${this.maxSortID}`);

            let task = {
                siteID: this.siteID,
                status: 'INCOMPLETE',
                //id: Math.random().toString(36).substr(2, 5),
                sortID: this.maxSortID ? this.maxSortID + 1 : 1,
                content: contentHTML,
                createdAt: moment().toDate(),
                dueAt: moment().toDate(),
                dueAtStr: moment().format('MM/DD/YYYY'),
                assignedToEmpID: assignedToEmpID,
                createdByEmpID: this.userID,
                timestamp: new Date().getTime(),
                timezone: this.allSettings.GENERAL_TIMEZONE.PropertyValue,
                lastActivity: moment().toDate(), // this will have the date when EITHER task or any comments on the task was updated
                deleted: false
            }

            let taggedPatients = this.getTaggedPatientIDs(contentHTML);
            if(taggedPatients.length > 0)
            task['taggedPatients'] = taggedPatients;

            let notification;

            if(assignedToEmpID !== this.userID) {
                notification = {
                    audience: 'EMPLOYEE',
                    employeeID: assignedToEmpID,
                    type: 'TASK',
                    text: `You have been assigned a <a href='/app/todo/#taskID#'>task</a> by ${this.user.Name}`,    // #taskID# will be replaced with the actual ID of the task
                    siteID: this.siteID,
                    createdAt: new Date(),
                    unreadList: new Array(assignedToEmpID)
                };
            }

            let payload = {
                task,
                ...(notification && { notification: notification }),
            }

            //console.log(`Task payload: ${JSON.stringify(payload, null, ' ')}`);

            try {          
                this.$refs['newtodo'].innerHTML = '';
                // store the items locally in local storage
                //this.storeItems();
                // store items in firebase
                await this.addPersonalTask(payload);
                this.$nextTick(() => this.$refs.newtodo.focus());
                this.setCaretAtBeginning();
            } catch(err) {
                //await this.deleteTask({id: task.id});
                console.error(err);
            }
        }
    },

    computed: {
        ...mapGetters({      
            'activeEmployees': 'customer/activeEmployees',       
            'getPatient': 'customer/getPatient',            
        }),

        ...mapState({
          loading: state => state.alert.loading,
          loaded: state => state.alert.loaded,
          errored: state => state.alert.errored,
          alertMessage: state => state.alert.message,
          dismissSuccessCountDown : state => state.alert.dismissSuccessCountDown,
          siteID: state => state.customer.siteID,
          userID: state => state.customer.userID,
          sites: state => state.customer.sites,
          employees: state => state.customer.employees,
          patients: state => state.customer.patients,
          tasksTaggedWithPatients: state => state.tasks.tasksTaggedWithPatients,
          tasksTaggedWithPatient: state => state.tasks.tasksTaggedWithPatient,
        }),

        quickNotesOptions2Setup() {
            return _.isEmpty(this.practicePulseSettings.quickNotesOptions2);
        },

        isSendEmailEnabled() {
            return !!(this.practicePulseSettings && this.practicePulseSettings.sendEmailTime);
        },

        patientOutofPocket() {
            if(this.checkoutNotes && this.checkoutNotes.length > 0) {
                return this.ppID === null ? this.checkoutNotes[0] : this.checkoutNotes[1];
            }
        },

        patientBalance() {
            if(this.checkoutNotes && this.checkoutNotes.length > 0) {
                return this.ppID === null ? this.checkoutNotes[1] : this.checkoutNotes[2];
            }
        },

        patientFamilyRecall() {
            if(this.checkoutNotes && this.checkoutNotes.length > 0) {
                return this.ppID === null ? this.checkoutNotes[2] : this.checkoutNotes[3];
            }
        },

        patientPlannedAppts() {
            if(this.checkoutNotes && this.checkoutNotes.length > 0) {
                return this.ppID === null ? this.checkoutNotes[3] : this.checkoutNotes[4];
            }
        },

       /*
        patientUpcomingFollowups() {
            if(this.checkoutNotes && this.checkoutNotes.length > 0) {
                return this.ppID === null ? this.checkoutNotes[4] : this.checkoutNotes[5];
            }
        }, 
        */       
    }
}

</script>

<style lang='scss' scoped>

.ToDo {
  &__items {
    margin-top: 1.5rem;
  }

  &__assignedToMe {
    margin-top: 20px
  }
}


:active :focus {
  border-color: #aba3ff;
}

.newtodo {
  width: 100%;
  padding: 5px 5px;
  font-weight: 400;
  //border: 1px solid grey ;
  background-color: #fff;
  border: 2px solid #e0e6e8;
  border-radius: 3px;
  line-height: normal;
  margin: 0;
  //padding: 0 0 0 16px;
  transition: border .15s;
  cursor: auto;
}

[contenteditable][placeholder]:empty:before {
  content: attr(placeholder);
  position: absolute;
  color: lightgray;
  background-color: transparent;
}

*[contenteditable="true"]{display: inline-block;}

.tooltip-inner {
  padding: -10px;
}

.quickNotes {
    height: 350px;
    overflow-y: scroll;
}

</style>

<style src="./CheckoutNotes.scss" lang="scss" />
